import { Dispatcher, getProxyObject, IDispatcher } from "@fanfanlo";
import { type IVisit } from '../../remote/visit/appStart';
import { useEffect } from "react";

export interface IAppModel {
  visitInfo?: IVisit
  dispatcher:IDispatcher
}

export enum AppModelEvent {
  InviteListUpdated = 'inviteListUpdated',
}

/**
 import {AppModelEvent, appModel} from '@app/model';
 import { useEffect } from "react";
 function iniviteListUpdated(){
  useEffect(()=>{
    return appModel.dispatcher.addListener(AppModelEvent.InviteListUpdated, ()=>{
      // 处理邀请列表更新事件，可以到后端重新拉取被邀请的列表。
      console.log('AppModelEvent.InviteListUpdated');
    });
  })
}
 */


// export class AppModelImpl extends Dispatcher implements IAppModel {
//   constructor() {

//     super();
//   }
//   visitInfo?: IVisit
// }
export const appModel:IAppModel = {
  visitInfo:undefined,
  dispatcher:new Dispatcher()
}
export const appProxyModelObject = getProxyObject(appModel)
export const appProxyModel = appProxyModelObject.proxy


